//  __         __     __   __     ______     __  __     ______        __   __     ______     ______  
// /\ \       /\ \   /\ "-.\ \   /\  ___\   /\ \/ /    /\  ___\      /\ "-.\ \   /\  ___\   /\__  _\ 
// \ \ \____  \ \ \  \ \ \-.  \  \ \ \__ \  \ \  _"-.  \ \  __\      \ \ \-.  \  \ \  __\   \/_/\ \/ 
//  \ \_____\  \ \_\  \ \_\"\_\  \ \_____\  \ \_\ \_\  \ \_____\     \ \_\"\_\  \ \_____\    \ \_\ 
//   \/_____/   \/_/   \/_/ \/_/   \/_____/   \/_/\/_/   \/_____/      \/_/ \/_/   \/_____/     \/_/ 
//                                                                                                   
// 所有权利归Lingke Network (china)所有 | dream_pep拥有其艺术改变权力
// 未经允许的情况下删除此版权头可能会受到民事指控
// 请勿在未经Lingke Network (china)允许的范围内修改代码并分发

import { z } from "zod";

export const TodoStatusEnum = z.enum([
  "todo",
  "in_progress",
  "completed",
  "archived",
]);

export type TodoStatus = z.infer<typeof TodoStatusEnum>;

export const PriorityEnum = z.enum(["low", "medium", "high"]);
export type Priority = z.infer<typeof PriorityEnum>;

export const VALID_TODO_SORT_FIELDS = [
  "title",
  "status",
  "priority",
  "dueDate",
  "completedAt",
  "createdAt",
  "updatedAt",
] as const;

export type TodoFiltersType = {
  status?: TodoStatus | string;
  priority?: Priority | string;
  search?: string;
  fromdue?: string;
  todue?: string;
  fromcompleted?: string;
  tocompleted?: string;
  isstarred?: boolean;
  sortBy?: (typeof VALID_TODO_SORT_FIELDS)[number] | string;
  sortOrder?: "asc" | "desc" | string;
  pageSize?: number;
};

export interface NewTodo {
  title: string;
  description?: string;
  status?: TodoStatus;
  priority?: Priority;
  dueDate?: string | null;
  completedAt?: string | null;
  isStarred?: boolean;
}

export interface UpdateTodo {
  title?: string;
  description?: string;
  status?: TodoStatus;
  priority?: Priority;
  dueDate?: string | null;
  completedAt?: string | null;
  isStarred?: boolean;
}
